"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

var _mdc = require("@material/menu/dist/mdc.menu");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable jsx-a11y/href-no-hash */

/**
 * Display a grid of available application icons.
 *
 * Use in conjunction with the Global Header components.
 */


var AppSwitcher = function (_React$Component) {
  _inherits(AppSwitcher, _React$Component);

  function AppSwitcher() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppSwitcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppSwitcher.__proto__ || Object.getPrototypeOf(AppSwitcher)).call.apply(_ref, [this].concat(args))), _this), _this.onCancel = function () {
      _this.props.onCancel();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppSwitcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.menu) {
        this.MDCComponent = new _mdc.MDCMenu(this.menu);
        this.MDCComponent.listen("MDCMenu:cancel", this.onCancel);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.MDCComponent) {
        this.MDCComponent.unlisten("MDCMenu:cancel", this.onCancel);
        this.MDCComponent.destroy();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.MDCComponent) {
        if (this.props.open !== prevProps.open) {
          this.MDCComponent.open = this.props.open;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          other = _objectWithoutProperties(_props, ["className", "children"]);

      return _react2.default.createElement("div", _extends({
        className: (0, _classnames2.default)("mdc-menu", "cdk-global-header__app-switcher", className),
        tabIndex: "-1",
        ref: function ref(menu) {
          _this2.menu = menu;
        }
      }, other), children);
    }
  }]);

  return AppSwitcher;
}(_react2.default.Component);

AppSwitcher.propTypes = {
  /**
   * Called when the app switcher is cancelled (ESC or clicking outside
   * the application grid).
   */
  onCancel: _propTypes.func
};
AppSwitcher.defaultProps = {
  onCancel: function onCancel() {}
};
exports.default = AppSwitcher;